export enum TipoPagamento {
  CartaoCredito = 1,
  CartaoDebito = 2,
  PicPay = 3,
  Pix = 4,
  PJPosPago = 5,
  Boleto = 6,
  YunoCredito = 7,
  YunoDebito = 8,
  YunoPix = 9
}
